// Frequency <-> MIDI <-> cents conversions with configurable A4 reference.

export const DEFAULT_A4 = 440;

// MIDI note number to frequency. A4 (MIDI 69) maps to A4 Hz.
export function midiToFreq(midi: number, A4 = DEFAULT_A4): number {
  return A4 * Math.pow(2, (midi - 69) / 12);
}

// Frequency to MIDI note number (fractional).
export function freqToMidi(freq: number, A4 = DEFAULT_A4): number {
  return 69 + 12 * Math.log2(freq / A4);
}

// Cents deviation of a frequency from the nearest equal-tempered semitone.
export function freqToCents(freq: number, A4 = DEFAULT_A4): number {
  const midi = freqToMidi(freq, A4);
  const rounded = Math.round(midi);
  return Math.round((midi - rounded) * 100);
}

// Nearest 12-TET frequency for a given frequency.
export function nearestNoteFreq(freq: number, A4 = DEFAULT_A4): number {
  return midiToFreq(Math.round(freqToMidi(freq, A4)), A4);
}

export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export function midiToName(midi: number): string {
  const n = Math.round(midi);
  const octave = Math.floor(n / 12) - 1;
  return `${NOTE_NAMES[((n % 12) + 12) % 12]}${octave}`;
}

// Which violin open string (0..3) a frequency is closest to, plus cents offset.
export function nearestString(freq: number, targets: [number, number, number, number]): { index: number; cents: number } {
  let best = 0;
  let bestCents = Infinity;
  for (let i = 0; i < 4; i++) {
    const cents = 1200 * Math.log2(freq / targets[i]);
    if (Math.abs(cents) < Math.abs(bestCents)) {
      bestCents = cents;
      best = i;
    }
  }
  return { index: best, cents: Math.max(-50, Math.min(50, bestCents)) };
}
